<!--suppress ALL -->

<template>
  <div>


    <div v-if="logs.length > 0" style="color: darkgray;margin-bottom: 10px;margin-top: 0px">生成记录
      <el-button
        style="margin-left: 20px" size="large" type="text" @click="refresh">刷新
      </el-button>
    </div>
    <div v-for="(log,key) in logs" :key="key"
         style="background: #f9f9f9;padding: 20px;margin-bottom: 10px;border-radius: 4px">

      <div style="display: flex; margin-bottom: 20px">
        <div style="color: darkgray">{{ log.createTime }} 创建</div>

        <el-dropdown style="margin-left: auto"><span class="el-dropdown-link">操作<i
          class="el-icon-arrow-down el-icon--right"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-download" @click.native="download(log.data.data)">下载</el-dropdown-item>
            <el-dropdown-item icon="el-icon-delete" @click.native="deleteLog(log.logId)">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-if="log.param && log.param.prompt" style="color: #7e7e7e; margin-top: 10px; margin-bottom: 10px">
        {{ log.param.prompt }}
      </div>
      <div style="margin-top: 10px;display: flex; " v-if="log.data">
        <img v-if="log.data.type =='image'" v-for="(item,key) in log.data.data" :src="item"
             :width="log.data.data.length == 1 ? '50%':'22%'" :key="key"
             style="margin-right: 20px; border: 1px solid #f4f4f4" class="ps-like-grid"
             @click="previewImg(item)"/>
        <div v-if="log.data.type =='text'">{{ log.data.data[0] }}</div>
        <div v-if="log.data.type =='voice'">


          <audio :src="log.data.data[0]" controls></audio>

          <div style="margin-top: 20px">
            <el-button class="btn" size="small" style="" @click="downloadFile(log.data.data[0])">
              <span>下载声音</span>
            </el-button>
          </div>

          <!--          <el-button class="btn" size="small" style="margin: 20px;" @click="playVoice(log.data.data[0])">-->
          <!--            <span>播放声音</span>-->
          <!--          </el-button>-->
        </div>


        <div v-if="log.data.type =='video'">

          <div v-if="log.data.data[0] !=''">
            <div v-if="log.data.data.length > 1" style="display: flex">
              <div v-for="(item,index) in log.data.data" :key="index"  style="margin-right: 40px">
                <video preload="none" style="width: 100px; height: auto" :src="item"
                       class="video-avatar" controls="controls">
                  您的浏览器不支持视频播放
                </video>
                <div style="margin-top: 20px">
                  <el-button  size="small" style="" @click="downloadFile(item)">
                    <span>下载视频</span>
                  </el-button>
                </div>
              </div>
            </div>
            <div v-if="log.data.data.length == 1">
              <video :poster="log.data.videoCover" preload="none" style="width: 150px; height: auto" :src="log.data.data[0]"
                     class="video-avatar" controls="controls">
                您的浏览器不支持视频播放
              </video>
              <div style="margin-top: 20px">
                <el-button class="btn" size="small" style="" @click="downloadFile(log.data.data[0])">
                  <span>下载视频</span>
                </el-button>
              </div>
            </div>
          </div>


          <div v-if="log.data.data[0] ==''">视频正在生成中 请稍后刷新</div>
        </div>

      </div>
      <div v-if="log.param && log.param.base_image_url" style="margin-top: 20px; margin-bottom: 10px">
        <div style="color: darkgray">原图</div>
        <img :src="log.param.base_image_url" style="width: 30%" @click="previewImg(log.param.base_image_url)"></div>
      <div v-if="log.param && log.param.bg_image_url" style="margin-top: 20px; margin-bottom: 10px">
        <div style="color: darkgray">背景图</div>
        <img :src="log.param.bg_image_url" style="width: 30%" @click="previewImg(log.param.bg_image_url)"></div>
    </div>

    <image-browser ref="imageBrowser"></image-browser>

  </div>
</template>


<script>

import ImageBrowser from "./ImageBrowser";

export default {
  name: 'Log',
  data() {
    return {

      logs: [],
      type: 0,
      agent_id: 0,
      group_id: 0,
    }
  },

  components: {ImageBrowser},
  methods: {

    init: function (type) {
      this.type = type;
      this.getLogs(type);
    },
    init: function (type, agent_id,group_id) {
      this.type = type;
      this.agent_id = agent_id
      this.group_id = group_id
      this.getLogs(type);
    },

    refresh: function () {
      this.getLogs(this.type);
    },

    previewImg(data) {
      this.$refs.imageBrowser.show(data)
    },

    //===========数据调用==============//
    getLogs: function (type) {

      const token = localStorage.getItem("token");
      const login = token != null && token != "";
      if (!login) {
        return
      }

      let that = this;
      this.$post(
        {
          context: that,
          loading: true,
          path: '/aigc/log/list/',
          params: {
            type: type,
            agent_id: this.agent_id || 0,
            group_id: this.group_id || 0
          },
          success: function (data) {
            that.logs = data.logs;
          }
        }
      )
    },

    deleteLog: function (logId) {
      let that = this;
      this.$get(
        {
          context: that,
          path: '/aigc/log/delete/',
          params: {log_id: logId},
          success: function (data) {
            that.$message({
              type: 'success',
              message: '删除成功'
            });
            that.refresh();
          }
        }
      )
    },


    downloadFile(file) {
      window.location.href = file;
    },
    // playVoice(file){
    //   this.$el.querySelector('audio');
    // },

    download(images) {
      for (var image of images) {
        this.downloadImage(image, image)
      }
    },


    downloadImage(src, name) {
      var image = new Image()
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        var canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        var context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        var url = canvas.toDataURL('image/png')
        var a = document.createElement('a')
        var event = new MouseEvent('click')
        a.download = name || 'photo'
        a.href = url
        a.dispatchEvent(event)
      }
      image.src = src
    }
  }

}
</script>
